// extracted by mini-css-extract-plugin
export default {"noBackground":"Mja-z"};